import React from "react";

export function CarouselItemComponent({children}) {
    return <div className="carouselItemContent">{children}</div>;
}
